import getDataProviderInfo from './DataProviderInfo/getDataProviderInfo';
import { isSmimeAttachment } from './isSmimeAttachmentType';
import { getAttachmentPolicyInfo } from 'owa-attachment-policy';
import { isImageFile, isThumbnailableDocument } from 'owa-file';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';
import {
    FILE_ATTACHMENT_TYPE,
    REFERENCE_ATTACHMENT_TYPE,
    ITEM_ID_ATTACHMENT_TYPE,
} from './attachmentConstants';

export default function shouldShowImageView(attachment: AttachmentType): boolean {
    const policyInfo = getAttachmentPolicyInfo(attachment, true);
    if (!policyInfo.directFileAccessEnabled || isSmimeAttachment(attachment.AttachmentId.Id)) {
        return false;
    }

    if (attachment.Thumbnail) {
        return true;
    }

    const isImageAttachment = isImageFile(
        attachment.Name,
        attachment.ContentType,
        false /* considerTiffAsImage */
    );
    const isThumbnailableDocumentAttachment = isThumbnailableDocument(attachment.Name);

    if (
        (attachment.__type === FILE_ATTACHMENT_TYPE ||
            attachment.__type === ITEM_ID_ATTACHMENT_TYPE) &&
        (isImageAttachment || isThumbnailableDocumentAttachment)
    ) {
        return true;
    }

    if (attachment.__type === REFERENCE_ATTACHMENT_TYPE) {
        const referenceAttachment = <ReferenceAttachment>attachment;
        const dataProviderInfo = getDataProviderInfo(referenceAttachment.ProviderType);

        if (
            referenceAttachment.AttachmentThumbnailUrl ||
            (isImageAttachment && dataProviderInfo && dataProviderInfo.supportImageThumbnail)
        ) {
            return true;
        }
    }

    return false;
}
